import { useRef } from 'react';

import { animate, useMotionValue } from 'framer-motion';

import { SIDEBAR_WIDTH } from '../constants/sidebar';

const SWIPE_CLOSE_THRESHOLD = 80;

export function useSwipeToClose(onClose: () => void) {
  const swipeX = useMotionValue(0);
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);
  const isHorizontalSwipe = useRef<boolean | null>(null);

  function handleTouchStart(e: React.TouchEvent) {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
    isHorizontalSwipe.current = null;
  }

  function handleTouchMove(e: React.TouchEvent) {
    const dx = e.touches[0].clientX - touchStartX.current;
    const dy = e.touches[0].clientY - touchStartY.current;

    if (isHorizontalSwipe.current === null) {
      if (Math.abs(dx) < 5 && Math.abs(dy) < 5) {
        return;
      }
      isHorizontalSwipe.current = Math.abs(dx) > Math.abs(dy);
    }

    if (isHorizontalSwipe.current && dx < 0) {
      swipeX.set(Math.max(dx, -SIDEBAR_WIDTH));
    }
  }

  function handleTouchEnd() {
    if (!isHorizontalSwipe.current) {
      return;
    }
    isHorizontalSwipe.current = null;

    if (swipeX.get() < -SWIPE_CLOSE_THRESHOLD) {
      onClose();
    } else {
      animate(swipeX, 0, { type: 'spring', damping: 35, stiffness: 300 });
    }
  }

  return {
    swipeX,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
  };
}
